import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import CustomFieldValue from "@mapmycustomers/shared/types/customField/CustomFieldValue";
import { CustomFieldValueType } from "@mapmycustomers/shared/types/customField/CustomFieldValueType";
import { OptionalFields } from "@mapmycustomers/shared/util/ts";

const buildCustomFieldValue = (
  definition: CustomField,
  value: CustomFieldValueType
): OptionalFields<CustomFieldValue, "id"> => ({
  crmPropertyKey: definition.crmPropertyKey,
  currencyId: definition.currencyId,
  customField: {
    id: definition.id,
  },
  dataType: definition.dataType,
  esKey: definition.esKey,
  options: definition.options,
  value,
});

export default buildCustomFieldValue;
